import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from 'app/_shared/project.config';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class GenericService<T>{

    public url: string;
    public rootUrl: string;

    protected constructor(protected _http: HttpClient, private _url: string, protected rootAPIurl: string = environment.Services.ApiURL) {
        this.url = environment.apiProtocol + rootAPIurl + _url;
        this.rootUrl = environment.apiProtocol + rootAPIurl
    }

    getAll(includeCache:boolean=false): Observable<T[]> {
        return this._http.get(this.url, this.prepareHeader(includeCache)).pipe(map(res => res as T[]))
    }

    getOneById(id): Observable<T> {
        return this._http.get(this.url + id, this.prepareHeader()).pipe(map(res => res as T))
    }

    save(body): Observable<string> {
        return this._http.post(this.url, body, this.prepareHeader()).pipe(map(res => res as any));
    }

    update(body): Observable<any> {
        return this._http.put(this.url, body, this.prepareHeader()).pipe(map(res => res as any));
    }

    delete(id): Observable<any> {
        return this._http.delete(this.url + id, this.prepareHeader()).pipe(map(res => res as any));
    }



    public prepareHeader(includeCache: boolean = false): Object  {
        let headersConfig = {
            'Content-Type': 'application/json'
        };

        if (!includeCache) {
            headersConfig['Cache-Control'] = 'no-cache';

        }

        return {
            headers: new HttpHeaders(headersConfig),
        };
    }
}